import React from "react";
import { VerticalTabWorkList } from "../../secondary/VerticalTabWorkList";
import style from "./workListCommon.module.scss";
import { useWorkListTabs } from "./hooks/useWorkListTabs";
import { WORKLIST_CONFIG } from "./worklistConfig";
import { WorklistScreen } from "./worklistScreen";

export function WoundPhotos({ facilityNumber }) {
  const { dispatch, onSelectVerTab, defaultVerTab, woundPhotosCount } = useWorkListTabs(facilityNumber, "patientSubmitedValues");

  const tabList = [
    {
      name: `Wound Photos ${woundPhotosCount}`,
      key: "woundPhotos",
      content: <WorklistScreen facilityNumber={facilityNumber} config={WORKLIST_CONFIG.woundPhotos} />,
      bottomName: "Pending Assessment",
      bgcolor: style.wound_photo_color,
    },
  ];
  return (
    <VerticalTabWorkList onSelectInt={onSelectVerTab} defaultIndex={defaultVerTab <= 1 ? defaultVerTab : 0} tabList={tabList} dispatch={dispatch} />
  );
}
